<script setup>
import { ref } from 'vue';
import { Sortable } from "sortablejs-vue3";
import axios from 'axios';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger
} from "@/shadcn/components/ui/dropdown-menu/index.ts";
import { ChevronDownIcon, GripVerticalIcon, PenIcon } from "@lucide/vue";
import { Button } from "@/shadcn/components/ui/button/index.ts";

const props = defineProps({
  categories: {
    type: Array,
    required: true
  },
  updateOrderUrl: {
    type: String,
    required: true
  }
});

const items = ref(props.categories);

function updateOrder(event) {
  items.value.splice(event.newIndex, 0, items.value.splice(event.oldIndex, 1)[0]);
  axios.put(props.updateOrderUrl, {
    order: items.value.map((item) => item.id)
  })
    .catch(function (error) {
      alert(error);
    });
}
</script>

<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th class="tw:w-10"></th>
          <th class="tw:text-left">{{ $t('Name') }}</th>
          <th class="tw:text-left">{{ $t('Activities') }}</th>
          <th class="tw:text-left tw:w-0"></th>
        </tr>
      </thead>
      <Sortable
        :list="items"
        item-key="id"
        tag="tbody"
        :options="{handle:'.draggable-handle'}"
        @end="updateOrder"
      >
        <template #item="{element: category}">
          <tr :key="category.id">
            <td class="align-middle">
              <span class="draggable-handle tw:cursor-grab tw:text-muted-foreground/50 active:tw:cursor-grabbing">
                <GripVerticalIcon class="tw:w-4 tw:h-4" />
              </span>
            </td>
            <td class="align-middle">
              <a :href="category.links.edit" class="tw:font-semibold">
                {{ category.name }}
              </a>
              <br>
              <span class="tw:text-muted-foreground">{{ category.code }}</span>
            </td>
            <td class="align-middle">
              {{ category.activities_count }}
            </td>
            <td class="align-middle tw:w-0 tw:whitespace-nowrap">
              <DropdownMenu>
                <DropdownMenuTrigger as-child>
                  <Button variant="outline">
                    {{ $t('Actions') }}
                    <ChevronDownIcon class="tw:ml-2 tw:h-4 tw:w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem as-child>
                    <a :href="category.links.edit" class="tw:text-zinc-800">
                      <PenIcon class="tw:w-4 tw:h-4" />
                      {{ $t('Edit') }}
                    </a>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </td>
          </tr>
        </template>
      </Sortable>
    </table>
  </div>
</template>
